<template>
<div id="m-account">
  <van-popup v-model:show="start_show" position="bottom" :style="{ height: '50%' }" :close-on-click-overlay="false">
    <van-datetime-picker
        v-model="time.start"
        @confirm="changeStartTime"
        @change="changeStartTime"
        type="date"
        title="选择年月日"
        :min-date="minDate"
    />
  </van-popup>
  <van-popup v-model:show="end_show" position="bottom" :style="{ height: '50%' }" :close-on-click-overlay="false">
    <van-datetime-picker
        v-model="time.end"
        @confirm="changeEndTime"
        @change="changeEndTime"
        type="date"
        title="选择年月日"
        :min-date="minDate"
    />
  </van-popup>
  <div class="main">
    <div class="page-type">
      <div :class="page == 1 ?'active' :''" @click="changePage(1)"><div>收益概览</div><span></span></div>
      <div :class="page == 2 ?'active' :''" @click="changePage(2)"><div>结算记录</div><span></span></div>
    </div>
    <div class="page" v-if="page ==1">
      <div class="top" v-if="user.approve == 1">
        <div class="line1">
          <div class="one">
            <span class="tit">可供结算的庭院积分</span>
            <div><span class="num">{{ date[1]>"2023-11-30"?"功能已下线":(user.score_real + "庭院积分")}}</span><span></span></div>
            <button @click="changeUrl('/m-account')"><img :src="icon9">查看明细</button>
          </div>
          <div class="one">
            <span class="tit">可兑换为庭院币</span>
            <div><span class="num">{{ date[1]>"2023-11-30"?"功能已下线":(Math.floor(user.score_real / 10)+"庭院币")}}</span><span></span></div>
            <span class="yes">当前持有庭院币：<span style="color: #00c3ff">{{user.price}}</span></span>
          </div>
        </div>
        <button v-if="date[1]>'2023-11-30'" class="btn2">功能已下线</button>
        <button v-else class="btn" @click="accountOrder">立即结算为庭院币</button>
        <div class="text">结算后，可供结算的庭院积分将清空，可在结算记录查询</div>
      </div>
      <div class="top" v-else>
        <div class="tit">使用收益结算功能，您需要先认证为创作者！</div>
        <div class="line1">
          <div class="one">
            <span class="tit">可供结算的庭院积分</span>
            <div><span class="num">{{ date[1]>"2023-11-30"?"功能已下线":(user.score_real + "庭院积分")}}</span><span></span></div>
            <button><img :src="icon9">查看明细</button>
          </div>
          <div class="one">
            <span class="tit">可兑换为庭院币</span>
            <div><span class="num">{{date[1]>"2023-11-30"?"功能已下线":(Math.floor(user.score_real / 10)+"庭院币")}}</span><span></span></div>
            <span class="yes">当前持有庭院币：<span style="color: #00c3ff">{{user.price}}</span></span>
          </div>
        </div>
        <button v-if="date[1]>'2023-11-30'" class="btn2">功能已下线</button>
        <button v-else class="btn2">立即结算为庭院币</button>
        <div class="text" style="color:red;">使用收益结算功能，您需要先认证为创作者！</div>
      </div>
      <div class="down">
        <span>结算说明</span>
        <div v-if="date[1]>'2023-11-30'" >
          <span style="color:red;margin-bottom: 20px;display: block;">结算庭院币功能已于2023年12月1日下线。功能下线不再受理新的庭院积分审核，无法申请结算为庭院币。在截止时间前已经提交审核的结算申请仍将完成审核结算。</span>
        </div>
        <div v-else>
          <span>1.当月的收益数据平台会在N+2月确认，并以庭院积分的形式兑换到账。</span>
          <span>2.庭院积分不可用于直接消费，将庭院积分兑换为庭院币后，可以在兑换商店使用庭院币进行消费。</span>
          <span>3.由于广告数据受广告商报价时间递延影响，广告实际收入可能会存在与预估数量不一致情况，请以最终结算数据为准，结算记录中可查看明细。</span>
          <span>4.点击“立即结算为庭院币”，可提交结算申请，工作人员审核通过后完成结算。可在“结算记录”查询审核状态，并关注后续通知。</span>
          <span class="d">查看具体详情：<router-link target="_blank" to="/protocol">《植物大战僵尸2创意庭院结算规则说明》</router-link></span>
        </div>
       
        
      </div>
    </div>
    <div class="page" v-else>
      <div class="top1">
        <div class="tit-1" >
          <div>选择日期</div>
          <a @click="exportData('../diy/export?type=account&start='+time.start+'&end='+time.end)"><button>导出数据</button></a>
        </div>
        <div class="time">
          <input @click="start_show = true" v-model="time.start"><div> ~ </div><input @click="end_show = true" v-model="time.end" />
        </div>
        <button class="search" @click="searchData">查找</button>
      </div>
      <div class="down1">
        <div class="tit">
          <div>日期</div><div>订单号</div><div>庭院积分数</div><div>兑换庭院币</div><div>状态</div>
        </div>
        <div class="tr" v-for="(item,index) in limitData" :key="index">
          <div>{{item.created_at}}</div>  <div>{{item.order_nb}}</div><div>{{item.score}}</div><div>{{item.price}}</div><div>{{item.status}}</div>
        </div>
        <span v-if="limitData.length < 5">没有更多啦~</span>
        <div class="pages">
          <van-pagination v-model="dataPage" :page-count="maxPage" :force-ellipses="true" :show-page-size="3" @change="changeData">
            <template #prev-text>
              <van-icon name="arrow-left" />
            </template>
            <template #next-text>
              <van-icon name="arrow" />
            </template>
            <template #page="{ text }">{{ text }}</template>
          </van-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {computed, ref} from "vue";
import {useStore} from "vuex";
import icon9 from "../../assets/icon-9.png"
import {ElMessage} from "element-plus";
import api from "@/api"
import {getFirstAndToday, getYmdTime} from "../../util/data";
console.log(getFirstAndToday())
import {useRouter} from "vue-router";
export default {
  name: "Account",
  setup(){
    const store = useStore();
    let page = ref(1)
    let start_show = ref(false)
    let end_show = ref(false)
    let loading = ref(false)
    let date = ref(getFirstAndToday())
    const time = ref({start:date.value[0],end:date.value[1]})
    const user = computed(() =>store.state.user.user);
    const router = useRouter()
    let data = ref([])
    let limitData = ref([])
    let maxPage  = ref(0)
    let dataPage  = ref(1)

    api.data.setAccess({page:'account'}).then(function (res){
      console.log(res)
    })
    const accountOrder = () =>{
      if (user.value.score_real < 10){
        ElMessage({
          message: '可结算庭院积分不足！',
          type: 'warning',
          duration: 5 * 1000
        })
        return
      }
      api.data.accountOrder().then(function (res){
        if (res.code == 0){
          store.dispatch('user/setUser',res.data);
          ElMessage({
            message: '申请成功，订单审核中，可在“结算记录”查询审核状态',
            type: 'success',
            duration: 5 * 1000
          })
        }else{
          ElMessage({
            message: res.msg,
            type: 'error',
            duration: 5 * 1000
          })
          if (res.code == 16){
            window.location.href='../diy/logout'
          }
        }
      })
    }
    const changeStartTime = (value) =>{
      time.value.start = getYmdTime(value)
      start_show.value = false;
    }

    const changeEndTime = (value) =>{
      time.value.end = getYmdTime(value)
      end_show.value = false;
    }
    const changePage = (n)=>{
      page.value = n;
      if (n ==2){
        searchData()
      }
    }
    const searchData = () =>{
      console.log('搜索')
      if (user.value.approve == 1){
        loading.value = true;
        api.data.getAccount({date:[time.value.start,time.value.end]}).then(function (res){
          data.value = res.data;
          loading.value = false;
          changeData(1)
          maxPage.value = Math.ceil(data.value.length / 5)
        }).catch(function (){
          loading.value = false;
        })
      }
    }
    const changeData = (n) => {
      dataPage.value = n
      limitData.value = [];
      let start = (dataPage.value - 1)*5
      let end = start + 5;
      if (end > data.value.length){
        end = data.value.length
      }
      for (let i=start;i< end;i++){
        limitData.value.push(data.value[i])
      }
      console.log(limitData)
    }

    const changeUrl = (m) => {
      router.replace(m);
    }
    const saveAs = (data,name)=>{
      const urlObject = window.URL || window.webkitURL || window;
      const export_blob = new Blob([data]);
      const save_link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
      save_link.href = urlObject.createObjectURL(export_blob);
      save_link.download = name;
      save_link.click();
    }
    const downloadUrlFile = (url) =>{
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'blob';
      //xhr.setRequestHeader('Authorization', 'Basic a2VybWl0Omtlcm1pdA==');
      // 为了避免大文件影响用户体验，建议加loading
      xhr.onload = () => {
        if (xhr.status === 200) {
          // 获取文件blob数据并保存
          saveAs(xhr.response,'导出数据.xlsx');
        }
      };
      xhr.send();
    }
    const exportData = (url) =>{
      api.data.sendUrl(url).then(res=>{
        if (res.code == 11){
          ElMessage({
            message: '暂无数据！',
            type: 'warning',
            duration: 5 * 1000
          })
        }else{
          downloadUrlFile(url)
        }
      })
    }
    return{
      date,page,changePage,user,icon9,accountOrder,time,start_show,end_show,minDate: new Date(2022, 0, 1),
      changeStartTime,changeEndTime,searchData,loading,dataPage,maxPage,changeData,limitData,changeUrl,exportData
    }
  }
}
</script>
<style>
.van-pagination {
  font-size: 24px !important;
  color: #999999;
}
.van-picker__cancel, .van-picker__confirm{
  font-size: 22px !important;
}
.van-picker__confirm{
  font-size: 22px !important;
}
.van-picker-column{
  font-size: 22px !important;
}
.van-picker__toolbar{
  height: 50px !important;
}
.van-picker__title{
  font-size: 22px !important;
  line-height: 40px !important;
}
.van-pagination__item{
  flex: initial !important;
  width: 30px !important;
  height: 30px !important;
  color: #999999 !important;
  border: 1px solid #f3bd1a;
  margin:  0 7px;
}
.van-pagination__item--active{
  background-color: #f3bd1a !important;
  color: white !important;
}
.van-pagination__item:active{
  background-color: #f3bd1a !important;
}
</style>
<style scoped lang="scss">
#m-account{
  width: 100%;
  height: 100%;
  display: flex;display:-webkit-flex;
  flex-direction: column;-webkit-flex-direction:column;
  align-items: center;-webkit-align-items: center;
  position: relative;
  .main{
    margin-top: 190px;
    width: 100%;
    height: auto;
    display: flex;display:-webkit-flex;
    flex-direction: column;-webkit-flex-direction:column;
    .page-type{
      font-size: 22px;
      color: white;
      height: 42px;
      margin-bottom: 30px;
      padding-left: 45px;
      display: flex;display:-webkit-flex;
      align-items: flex-end;-webkit-align-items: flex-end;
      .active{
        font-size: 32px;
        span{
          display: block;
        }
      }
      div{
        display: flex;display:-webkit-flex;
        flex-direction: column;-webkit-flex-direction:column;
        justify-content: flex-start;-webkit-justify-content: flex-start;
        margin-right: 35px;
        div{
          margin-bottom: 10px;
          text-align: left;
        }
        span{
          display: none;
          height: 2px;
          background-color: white;
          width: 26px;
        }
      }
    }
    .page{
      flex: 1;
      display: flex;display:-webkit-flex;
      flex-direction: column;-webkit-flex-direction:column;
      align-items: center;-webkit-align-items: center;
      .top{
        width: 698px;
        height: 530px;
        margin-top: 25px;
        background: url("../../assets/m-017.png") no-repeat;
        background-size: 100% 100%;
        position: relative;
        .line1{
          width: 100%;
          display: flex;display:-webkit-flex;
          justify-content: center;-webkit-justify-content: center;
          margin-top: 80px;
          height: auto;
          .one{
            background: url("../../assets/m-018.png") no-repeat;
            background-size: 100% 100%;
            width: 301px;
            height: 194px;
            display: flex;display:-webkit-flex;
            flex-direction: column;-webkit-flex-direction:column;
            align-items: center;-webkit-align-items: center;
            justify-content: center;-webkit-justify-content: center;
            font-size: 18px;
            margin: 0 15px;
            div{
              height: auto;
              color: #50b439;
              margin: 20px 0;
              .num{
                font-size: 28px;
                margin-right: 15px;
              }
            }
            .tit{
              font-size: 21px;
            }
            button{
              width: 140px;
              border-radius: 5px;
              font-size: 18px;
              color: #00c3ff;
              border: 1px solid #00c3ff;
              height: 36px;
              background: none;
              display: flex;display:-webkit-flex;
              align-items: center;-webkit-align-items: center;
              justify-content: center;-webkit-justify-content: center;
              img{
                width: 22px;
                margin-right: 10px;
                height: 22px;
              }
            }
            .yes{
              color: #999999;
            }
          }
        }
        .btn{
          width: 320px;
          border-radius: 5px;
          background-color: #00c3ff;
          font-size: 30px;
          color: white;
          border: none;
          height: 60px;
          margin-top: 34px;
          margin-bottom: 20px;
        }
        .btn2{
          width: 320px;
          border-radius: 5px;
          background-color: #d6d6d6;
          font-size: 30px;
          color: white;
          border: none;
          height: 60px;
          margin-top: 34px;
          margin-bottom: 20px;
        }
        .text{
          width: 100%;
          font-size: 20px;
          color: #999999;
        }
        .tit{
          position: absolute;
          top: 0px;
          left: 10px;
          right: 10px;
          height: 60px;
          background-color: #f3bd1a;
          border-radius: 5px 5px 0 0;
          font-size: 22px;
          color: black;
          display: flex;display:-webkit-flex;
          justify-content: center;-webkit-justify-content: center;
          align-items: center;-webkit-align-items: center;
        }
      }
      .top1{
        width: 628px;
        height: 358px;
        margin-top: 25px;
        padding: 0 35px;
        background: url("../../assets/m-017.png") no-repeat;
        background-size: 100% 100%;
        display: flex;display:-webkit-flex;
        flex-direction: column;-webkit-flex-direction:column;
        align-items: center;-webkit-align-items: center;
        .tit-1{
          width: 100%;
          padding-top: 40px;
          padding-bottom: 60px;
          font-size: 22px;
          display: flex;display:-webkit-flex;
          justify-content: space-between;
          button{
            color: black;
            width: 160px;
            border: none;
            height: 40px;
            border-radius: 10px;
            background-color: #f3bd1a;
          }
          div{
            height: auto;
            border-radius: 10px;
            width: auto;
            font-size: 30px;
          }
        }
        .time{
          width: 100%;
          display: flex;display:-webkit-flex;
          justify-content: center;-webkit-justify-content: center;
          div{
            margin: 25px 17px;
            height: 5px;
          }
          input{
            width: 230px;
            height: 58px;
            border-radius: 10px;
            background-color: #d6d6d6;
            color: black;
            font-size: 30px;
            text-align: center;
            border: none;
          }
        }
        .search{
          width: 230px;
          height: 60px;
          color: white;
          background-color: #50b439;
          font-size: 30px;
          margin-top: 35px;
          border: none;
          border-radius: 10px;
        }
      }
      .down{
        margin-top: 30px;
        width: 100%;
        height: 400px;
        padding-top: 55px;
        background-color: white;
        display: flex;display:-webkit-flex;
        flex-direction: column;-webkit-flex-direction:column;
        div{
          display: flex;display:-webkit-flex;
          flex-direction: column;-webkit-flex-direction:column;
        }
        span{
          font-size: 20px;
          margin-left: 60px;
          text-align: left;
          width: 615px;
        }
        .d{
          margin-top: 45px;
          a{
            color: #00c3ff;
          }
        }
      }
      .down1 {
        width: 100%;
        margin-top: 30px;
        height: 640px;
        background-color: white;
        display: flex;display:-webkit-flex;
        flex-direction: column;-webkit-flex-direction:column;
        align-items: center;-webkit-align-items: center;
        border-radius: 15px 15px 0 0;
        overflow: auto;
        .tit{
          width: 835px;
          border-radius: 15px 15px 0 0;
          height: 80px;
          display: flex;display:-webkit-flex;
          align-items: center;-webkit-align-items: center;
          background-color: #f3bd1a;
          justify-content: center;-webkit-justify-content: center;
          padding-left: 80px;
          div{
            flex: 1;
            font-size: 22px;
            color: #333333;
          }
        }
        .tr{
          width: 835px;
          height: 70px;
          display: flex;display:-webkit-flex;
          align-items: center;-webkit-align-items: center;
          padding-left: 80px;
          border-bottom: 1px solid #f2f2f2;
          div{
            flex: 1;
            font-size: 22px;
            color: #333333;
          }
        }
        span{
          font-size: 22px;
          color: #999999;
          margin-top: 20px;
        }
        .pages{
          width: 100%;
          height: 80px;
          display: flex;display:-webkit-flex;
          justify-content: center;-webkit-justify-content: center;
          align-items: center;-webkit-align-items: center;
          margin-top: 50px;
        }
      }
    }
  }
}
</style>
